import React, { useEffect, useState } from "react";
import Loader from "../../common/Loader";
import { ColorArray } from "../../config/ColorArray";
import { getSubjectsByStandard } from "../../utils/subjectService";
import "./Subjects.css";
import SectionDivider from "../../common/SectionDivider";

const Subjects = () => {
  const [subjects, setSubjects] = useState([]);
  const [standardIndex, setStandardIndex] = useState(1);
  const [selectedSession, setSelectedSession] = useState(1);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const sub = localStorage.getItem("subjectsData");
    const std = localStorage.getItem("selectedStandard");

    if (sub) setSubjects(JSON.parse(sub));
    if (std) {
      const parsedStd = JSON.parse(std);
      if (parsedStd?.standard_index != null) {
        setStandardIndex(Number(parsedStd.standard_index));
      }
    }
  }, []);

  useEffect(() => {
    // Check if navodaya subjects are already loaded
    const source = localStorage.getItem("subjectsSource");
    const existingSub = localStorage.getItem("subjectsData");
    
    if (source && existingSub && (source.includes("navodaya") || source.includes("gnansetu") || source.includes("nmms"))) {
      // Don't re-fetch for navodaya routes - use stored filtered subjects
      setSubjects(JSON.parse(existingSub));
      return;
    }
    
    let ignore = false;

    const fetchSubjects = async () => {
      setLoading(true);
      try {
        const data = await getSubjectsByStandard(standardIndex);
        if (ignore) return;
        setSubjects(data);
        localStorage.setItem("subjectsData", JSON.stringify(data));
      } finally {
        if (!ignore) setLoading(false);
      }
    };

    if (standardIndex != null) fetchSubjects();
    return () => {
      ignore = true;
    };
  }, [standardIndex]);

  const uiColor = ColorArray?.[0]?.color2 || "#3b82f6";

  return (
    <>
      <div className="std">
        <SectionDivider
          title={`પ્રાથમિક વિભાગ ના ધોરણ ${standardIndex} ના વિષયો`}
        />
      </div>
      <div className="subjects-screen">

        <div className="session-toggle">
          <button
            className={`session-button ${selectedSession === 1 ? "active" : ""}`}
            style={selectedSession === 1 ? { background: uiColor } : undefined}
            onClick={() => setSelectedSession(1)}
          >
            સત્ર  1  
          </button>
          <button
            className={`session-button ${selectedSession === 2 ? "active" : ""}`}
            style={selectedSession === 2 ? { background: uiColor } : undefined}
            onClick={() => setSelectedSession(2)}
          >
            સત્ર 2
          </button>
        </div>

        {/* <div className="section-header">
        <div className="section-line" />
        <div className="section-label" style={{ background: uiColor }}>
          ધોરણ {standardIndex} ના વિષયો
        </div>
        <div className="section-line" />
      </div> */}

        <div className="subjects-list">
          {loading ? (
            <Loader />
          ) : subjects.length === 0 ? (
            <div style={{ textAlign: "center", color: "#6b7280", padding: "20px" }}>
              No subjects found
            </div>
          ) : (
            subjects.map((s, index) => {
              const colorData = ColorArray[index % ColorArray.length];
              const color1 = colorData ? colorData.color1 : "#968bf7";
              const color2 = colorData ? colorData.color2 : "#1c00ff";

              return (
                <div
                  key={s.id}
                  className="subject-card"
                  style={{
                    background: `linear-gradient(to bottom, ${color1}, ${color2})`,
                  }}
                >

                  {/* IMAGE */}
                  {s.subject_image && (
                    <img
                      src={s.subject_image}
                      alt={s.subject_title}
                      className="subject-image"
                    />
                  )}

                  {/* NAME */}
                  <p className="subject-name">
                    {s.subject_title}
                  </p>

                </div>
              );
            })
          )}
        </div>
      </div>
    </>
  );
};

export default Subjects;
